const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  menu: state => state.user.menus,
  userId: state => state.user.id,
  addtemplate: state => state.caches.addtemplate,
  config: state => state.app.config,
  login: state => state.app.config.login,
  checkSessionUrl: state => state.user.checkSessionUrl,
  width: state => state.app.width,
  imagePath: state => state.user.imagePath,
  regionLevel5Switch: state => state.user.regionLevel5Switch,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js